const location = window.location;

export default location;
